<template>
    <Head title="Cadastrar Execução" />
    <AuthenticatedLayout>
        <Heading title="Cadastrar Execução" class="px-4 pb:px-[16vw] xl:pt-24 pb:pb-8 sm:pl-6 pt-28" />

        <div class="px-4 py-6 min-h-[60vh] xl:px-[15.5vw] flex flex-col gap-y-4">
            <section class="h-full z-10 flex flex-col mb-8 items-center justify-center" v-if="showResponseModal">
                <h1 class="text-center text-2xl font-bold text-primary">Execução enviada com sucesso!</h1>
                <img src="/images/pessoas-home-deslogada-desktop.png" class="object-cover xl:max-w-[40vw] sm:max-w-['110vw'] max-w-[80vw] my-4 "/>
                <div class="flex gap-x-8 justify-center py-2">
                        <a :href="route('dashboard')">
                            <button
                                class="px-4
                                    py-2
                                    bg-white
                                    border
                                    border-primary
                                    rounded-full
                                    font-bold
                                    text-primary
                                    hover:bg-gray-300
                                    hover:border-gray-300"
                            >
                                Home
                            </button>
                        </a>
                        <button
                            class="px-4
                                py-2
                                bg-primary
                                rounded-full
                                font-bold
                                text-white
                                hover:bg-highlight"
                            @click.prevent="restart();"
                        >
                            Enviar outra execução
                        </button>
                    </div>
            </section>
            <div v-else>
                <BackButton @onBack="prevStage()"/>
                <UploadPhotosCard v-if="!hasContestSelected" :currentRegion="currentRegion" @updateContest="loadContest($event)"/>
                <section class="h-full z-10 sm:flex sm:flex-col items-center justify-center" v-if="formStage === 0 && hasContestSelected">
                    <div class="" v-if="formList.length === 0">
                        <p>
                            Você pode fazer o upload de até 5 fotos por execução.
                            Para começar, toque no botão abaixo e preencha os itens.
                        </p>
                    </div>
                    <div class="mb-11" v-else>
                        <h1 class="font-bold">Resumo - Suas Execuções</h1>
                    </div>
                    <div class="flex flex-wrap gap-2 sm:justify-center">
                        <div v-for="(form, key) in formList" :key="key">
                            <h1 class="font-bold text-primary">
                                Execução {{ key + 1 }}
                            </h1>
                            <UploadExecution @onEdit="editExecution(form)"
                                @onRemove="removeExecution(form)"
                                class="mt-2"
                                :uploadExecution="form"
                                :enableSendNespoints="
                                    canSendToNespoints
                                "/>
                        </div>
                    </div>
                    <div class="mt-10 flex sm:flex-col gap-6 justify-center">
                        <div class="max-w-[330px] leading-4">
                            <Button class="max-w-[330px] border-dashed relative min-w-[230px]"
                                :disabled="disableButton"
                                @focusin="showTooltip = true"
                                @focusout="showTooltip = false"
                                @mouseenter="showTooltip = true"
                                @mouseleave="showTooltip = false"
                                :enabled="formList.length < 10"
                                @click="addExecution()">
                                <div class="grid grid-icon-template
                                    justify-items-center
                                    items-center gap-x-2">
                                    <Icon name="InformationCircle" /> <label class="whitespace-nowrap">Replicar dados Loja</label>
                                </div>
                                <div v-if="showTooltip"
                                    class="absolute right-0 -translate-y-24 pointer-events-none rounded-full py-2 px-4 bg-primary text-white text-xs">
                                    Esse botão permite realizar até 10 uploads, de execuções diferentes, replicando as informações da loja, campanha e participantes preenchidos anteriormente
                                </div>
                            </Button>
                            <div class="px-2 mt-1">
                                <label class="sm:block hidden text-sm text-left text-[#808080]">Esse botão permite realizar até 10 uploads, de execuções diferentes, replicando as informações da loja, campanha e participantes preenchidos anteriormente</label>
                            </div>
                        </div>
                        <LoadingButton v-if="formList.length > 0"
                            class="max-w-[330px] !bg-primary !text-white min-w-[230px]"
                            :disabled="executionsWithError?.length > 0 || disableButton"
                            :isLoading="disableButton"
                            @click="
                                executionsWithError?.length > 0
                                    ? (this.openModal('invalid-execution'))
                                    : (this.submit())
                            ">
                            {{ disableButton? '': 'Enviar Execução' }}
                        </LoadingButton>

                        <Modal title="Execução inválida" :showModal="isInvalidExecutionModalOpen" @closeModal="closeModal('invalid-execution')">
                            <p class="mt-2.5">
                                Para concluir esta operação, remova ou edite as
                                execuções inválidas.
                            </p>
                            <div class="flex gap-x-8 justify-center mt-5">
                                <button @click="closeModal('invalid-execution')"
                                    class="px-4
                                        py-2
                                        bg-primary
                                        rounded-full
                                        font-bold
                                        text-white
                                        hover:bg-highlight
                                        cursor-pointer">
                                    Fechar
                                </button>
                            </div>
                        </Modal>
                        <Modal :showModal="isResponseErrorModalOpen" @closeModal="closeModal('response-error')">
                            <h1 class="text-[20px] font-bold text-primary">
                                Falha ao registrar execução
                            </h1>
                            <p class="mt-2.5">
                                Infelizmente ocorreu erro e não foi possível subir sua
                                foto no momento, por favor tente mais tarde!
                            </p>
                            <div class="flex gap-x-8 justify-center mt-5">
                                <button @click="closeModal('response-error')"
                                    class="px-4
                                        py-2
                                        bg-primary
                                        rounded-full
                                        font-bold
                                        text-white
                                        hover:bg-highlight
                                        cursor-pointer">
                                    Fechar
                                </button>
                            </div>
                        </Modal>
                    </div>
                </section>
                <section v-if="formStage !== 0 && hasContestSelected" class="sm:flex sm:flex-col items-center justify-center">
                    <div class="grid items-center justify-center mt-2 mb-8">
                        <Wizard v-model="formStage" :steps="4" :enabledSteps="stageEnabled"/>
                    </div>
                    <Modal :showModal="isSendNespointsModalOpen"
                        @closeModal="closeModal('send-nespoints'); openFileInput();"
                        title="Deseja enviar o upload para Nespoints">

                        <div class="flex gap-x-8 justify-center mt-5">
                            <button
                                class="px-4
                                    py-2
                                    bg-white
                                    border
                                    border-primary
                                    rounded-full
                                    font-bold
                                    text-primary
                                    hover:bg-gray-300
                                    hover:border-gray-300"
                                @click="changeSendToNespoints(false); closeModal('send-nespoints'); openFileInput();"
                            >
                                Não
                            </button>
                            <button
                                class="px-4
                                    py-2
                                    bg-primary
                                    rounded-full
                                    font-bold
                                    text-white
                                    hover:bg-highlight"
                                :class="
                                    disableButton
                                        ? 'bg-blue-100 cursor-not-allowed pointer-events-none'
                                        : ''
                                "
                                @click.prevent="changeSendToNespoints(true); closeModal('send-nespoints'); openFileInput();"
                            >
                                Sim, enviar
                            </button>
                        </div>
                    </Modal>
                    <Modal :showModal="isConfirmSoldModalOpen"
                        @closeModal="closeModal('confirm-sold')"
                        :title="`SOLD na Sub-regional ${currentActivity?.subregion?.name}`">
                        <p class="mt-2.5">
                            Seu último check-in foi no SOLD {{ currentActivity?.pdv?.codeSoldBroker }} Sub-regional {{ currentActivity?.subregion?.name }}. Fazer upload para este sold?
                        </p>
                        <div class="flex gap-x-8 justify-center mt-5">
                            <button
                                class="px-4
                                    py-2
                                    bg-white
                                    border
                                    border-primary
                                    rounded-full
                                    font-bold
                                    text-primary
                                    hover:bg-gray-300
                                    hover:border-gray-300
                                "
                                @click="openModal('change-sold')"
                            >
                                Trocar SOLD
                            </button>
                            <button
                                class="px-4
                                    py-2
                                    bg-primary
                                    rounded-full
                                    font-bold
                                    text-white
                                    hover:bg-highlight"
                                :class="
                                    disableButton
                                        ? 'bg-blue-100 cursor-not-allowed pointer-events-none'
                                        : ''
                                "
                                @click.prevent="if(canSendToNespoints) openModal('send-nespoints'); else  openFileInput(); closeModal('confirm-sold')"
                            >
                                Sim, manter SOLD
                            </button>
                        </div>
                    </Modal>
                    <ChangeSoldCheckinModal :currentRegion="currentRegion" :showModal="isChangeSoldModalOpen" @closeModal="closeModal('change-sold')"/>
                    <section class="max-w-[330px]" v-show="formStage === 1" >
                        <p class="font-bold">Suba suas fotos</p>
                        <input ref="input-file" type="file" class="hidden" accept="image/*" id="inputImg" @input="loadPhoto" multiple />
                        <div v-if="form.files.length == 0" class="w-full border rounded-xl p-4 mt-4">
                            <label @click="openFileInput"
                                class="transition-all w-full h-[200px] flex justify-center items-center border rounded-xl border-dashed border-black bg-gray-200 hover:bg-gray-300 hover:text-blue-600 text-sm hover:underline cursor-pointer">
                                <p>Clique aqui para subir uma imagem</p>
                            </label>
                            <p class="text-xs mt-4">
                                Você pode subir até 5 imagens. Para cada imagem você
                                pode adicionar uma execução e uma categoria. Somente
                                imagens no formato jpeg ou png.
                            </p>
                        </div>
                        <div v-for="(file, key) in form.files" :key="key" :class="{
                            'border-error': file.fileStatus.status == 'error',
                            'border-success': file.fileStatus.status != 'error' && !file.fileStatus.hashAlreadyExistsInFormList && !file.fileStatus.hashAlreadyExistsInDatabase,
                            'border-yellow': file.fileStatus.hashAlreadyExistsInFormList || file.fileStatus.hashAlreadyExistsInDatabase,
                        }
                        " class="w-full border rounded-xl p-4 mt-4">
                            <div
                                class="transition-all w-full h-[200px] flex justify-center items-center border rounded-xl border-dashed border-black bg-gray-200 hover:bg-gray-300 hover:text-blue-600 text-sm hover:underline cursor-pointer">
                                <img class="object-contain w-full h-[200px] rounded-xl" :src="file.src" />
                            </div>
                            <div class="flex items-center justify-between mt-4">
                                <div>
                                    <p class="text-xs">
                                        {{ file.name }}
                                    </p>
                                    <p class="text-[10px] mt-2" :class="{
                                        'text-error': file.fileStatus.status == 'error',
                                        'text-success': file.fileStatus.status != 'error' && !file.fileStatus.hashAlreadyExistsInFormList && !file.fileStatus.hashAlreadyExistsInDatabase,
                                        'text-[#ff6a00]': file.fileStatus.hashAlreadyExistsInFormList || file.fileStatus.hashAlreadyExistsInDatabase,
                                    }">
                                        {{
                                            file.fileStatus.message
                                        }}
                                    </p>
                                </div>
                                <div class="h-full flex items-center">
                                    <Icon class="cursor-pointer" name="Fechar" @click="removeFile(key)" />
                                </div>
                            </div>
                        </div>
                        <div class="grid grid-icon-template gap-x-2 mt-4">
                            <Icon class="text-[#808080] mt-1" name="InformationCircle" />
                            <p class="pb-4 pt-0 text-sm text-[#808080]">
                                Adicione até 5 fotos da mesma execução de ângulos diferentes
                            </p>
                        </div>
                        <Button :enabled="form.files.length < 5"
                            @click="openFileInput"
                            type="button"
                            class="
                                w-full
                                grid
                                justify-items-center
                                items-center
                                font-semibold
                                bg-white
                                border-2 rounded-3xl
                                hover:bg-gray-300
                                hover:border-gray-300
                                transition-all
                                p-2 border-primary text-primary
                                max-w-[330px]
                                border-dashedmt-10
                                border-dashed
                            ">
                            <div class="grid grid-icon-template
                                justify-items-center
                                items-center gap-x-2">
                                <Icon name="InformationCircle" /> <label class="whitespace-nowrap">Adicionar mais fotos</label>
                            </div>
                        </Button>
                    </section>
                    <section class="max-w-[330px]" v-show="formStage === 2" >
                        <p class="text-xs text-error mb-2">
                            Lembre-se de marcar <strong>todos</strong> os participantes dessa execução.
                        </p>
                        <p class="font-bold text-black">
                            Seleção de Equipe
                            <span v-if="form.team.length > 0" class="text-gray-300 text-xs ml-4">Selecionados: {{ form.team.length
                            }}</span>
                        </p>
                        <div class="relative">
                            <button @click.prevent="
                                showSelectParticipants = !showSelectParticipants
                            "
                                class="text-black border-gray-500 focus:border-gray-300 transition-all form-select border rounded-2xl w-full text-left max-h-[42px] mt-1 hover:bg-gray-300 hover:border-gray-300">
                                Selecione os participantes da equipe
                            </button>
                        </div>
                        <div v-show="showSelectParticipants">
                            <div class="relative">
                                <input v-model="searchName"
                                    placeholder="Selecione os participantes da equipe"
                                    class="
                                        text-black
                                        border-gray-300
                                        focus:border-gray-300
                                        transition-all
                                        form-select
                                        border
                                        rounded-2xl
                                        w-full
                                        text-left
                                        max-h-[42px]
                                        mt-1
                                    "
                                    />
                                <div
                                    class="flex justify-center items-center absolute top-[5px] right-[1px] h-[40px] w-[40px] rounded-2xl bg-gray-200">
                                    <Icon name="Pesquisar" class="w-[16px]" />
                                </div>
                            </div>
                            <div v-if="filteredUsers?.length"
                                class="flex flex-col border border-gray-300 bg-white rounded-2xl mt-2">
                                <label class="flex items-center gap-x-2 p-2" :class="user == users[0] ? '' : 'border-t-2'"
                                    v-for="(user, key) in filteredUsers" :key="user.id">
                                    <input type="checkbox" :value="user" @click="setUser(user)" :ref="'checkbox-' + key"
                                        :checked="hasUser(user)" />
                                    <p>{{ user.user?.name }} {{ user.codeSap }}</p>
                                </label>
                            </div>
                            <div v-else class="grid my-2">
                                <label class="text-center text-lg text-[#808080]">
                                    Não encontramos nenhum resultado para o termo digitado
                                </label>
                            </div>
                        </div>
                    </section>
                    <section v-show="formStage === 3">
                        <div class="flex flex-wrap gap-x-4 w-full">

                        <h1 class="font-bold">Tipo de Execução</h1>
                            <SelectRadioWithImage :options="executions" class="max-w-[330px] w-full z-10"
                                :initialValue="form.execution"
                                @updateValue="form.execution = $event" />
                        </div>
                        <label v-if="form.execution.weight" class="font-bold flex flex-col">Peso - Foto
                            <input disabled :value="`Peso ${form.execution.weight}`"
                                class="form-input border rounded-full max-w-[330px] w-full m-[1px] disabled:border-gray-300 disabled:bg-gray-300" />
                        </label>
                    </section>
                    <section v-show="formStage === 4">
                        <SearchableExpandableCheckbox :options="categories"
                            title="Subcategoria"
                            placeholder="Selecione uma subcategoria"
                            class="max-w-[330px] full z-10"
                            :initialValue="form.categories"
                            @updateValue="form.categories = $event" />
                    </section>
                    <Button v-show="formStage > 0"
                        class="max-w-[330px] !z-0 mt-8 bg-primary !text-white"
                        :enabled="isValidStage"
                        @click.prevent="nextStage()"
                    >Avançar</Button>
                </section>
            </div>
        </div>
    </AuthenticatedLayout>
</template>
<script>
import moment from "moment";
import { Head } from "@inertiajs/inertia-vue3";
import AuthenticatedLayout from "@/Layouts/Authenticated.vue";
import Heading from "@/Components/UI/Texts/Heading.vue";
import ExpandableRadio from "@/Components/ExpandableRadio.vue";
import SearchableExpandableRadio from "@/Components/SearchableExpandableRadio.vue";
import SearchableExpandableCheckbox from "@/Components/SearchableExpandableCheckbox.vue";
import Input from "@/Components/UI/Form/Input.vue";
import Icon from "@/Components/UI/Icons/Icon.vue";
import Button from "@/Components/Button.vue";
import LoadingButton from "@/Components/LoaderButton.vue";
import UploadExecution from "@/Components/UploadExecution.vue";

import ChangeSoldCheckinModal from "@/Components/UI/Modals/ChangeSoldCheckinModal.vue";
import BackButton from "@/Components/UI/Nav/BackButton.vue";
import Modal from "@/Components/UI/Modals/Modal.vue";

import { v4 as uuidV4 } from "uuid";
import SelectRadioWithImage from "@/Components/UI/Form/SelectRadioWithImage.vue";
import Wizard from "@/Components/UI/Form/Wizard.vue";
import UploadPhotosCard from "@/Components/UI/Dashboard/UploadPhotosCard.vue";
import * as Sentry from "@sentry/vue";

const ContestExecutionTypes = [
    {
        name: 'ILHA',
        imageUrl: '/images/execution-types/ilha.png'
    },
    {
        name: 'TERMINAL',
        imageUrl: '/images/execution-types/terminal.png'
    },
    {
        name: 'DISPLAY',
        imageUrl: '/images/execution-types/display.png'
    },
    {
        name: 'CROSS',
        imageUrl: '/images/execution-types/cross.png'
    },
    {
        name: 'LOJA PERFEITA ANTES',
        imageUrl: undefined
    },
    {
        name: 'LOJA PERFEITA DEPOIS',
        imageUrl: undefined
    },
    {
        name: 'CHECKOUT',
        imageUrl: '/images/execution-types/checkout.png'
    },
    {
        name: 'CLIP STRIP',
        imageUrl: '/images/execution-types/clip-strip.png'
    },
    {
        name: 'PONTO NATURAL',
        imageUrl: '/images/execution-types/ponto-natural.png'
    },
    {
        name: 'RUPTURA ZERO',
        imageUrl: '/images/execution-types/ruptura-zero.png'
    },
    {
        name: 'PONTO EXTRA REFRIGERADO',
        imageUrl: '/images/execution-types/ponto-refrigerado.png'
    },
    {
        name: 'PONTO EXTRA',
        imageUrl: undefined
    },
]


export default {
    components: {
    AuthenticatedLayout,
    Head,
        Heading,
        SearchableExpandableRadio,
        SearchableExpandableCheckbox,
        ExpandableRadio,
        Input,
        Icon,
        Button,
        LoadingButton,
        UploadExecution,
        BackButton,
        Modal,
        ChangeSoldCheckinModal,
        SelectRadioWithImage,
        Wizard,
        UploadPhotosCard,
}   ,

    props: {
        stores: Object,
        currentRegion: Object,
        currentContest: Object,
    },

    watch: {
        currentActivity(currentActivity, previousActivity) {
            this.form.store = { ...currentActivity.pdv };
            if ((currentActivity?.pdv?.regionId !== previousActivity?.pdv?.regionId) || this.users?.length < 1) {
                this.loadPdvRegion(currentActivity?.pdv?.regionId)
            }
        },
    },

    mounted() {
        Sentry.setTag("userId", this.$page.props.auth.user?.id);

        this.loadContest(this.currentContest?.id);
        this.addExecution();
        this.openModal('confirm-sold');
        this.loadCurrentActivity();
    },

    data() {
        return {
            users: [],
            contests: [],
            executions: [],
            categories: [],
            modals: {
                'invalid-execution': false,
                'send-nespoints': false,
                'confirm-sold': false,
                'change-sold': false,
                'response-error': false,
            },
            form: {
                store: "",
                campaign: this.currentContest,
                categories: [],
                execution: "",
                team: [],
                files: [],
                sendToNespoint: false,
            },
            formList: [],
            formStage: 0,

            showSelectParticipants: false,
            searchName: '',

            responseList: [],
            disableButton: false,
            showTooltip: false,
            showResponseModal: false,
        }
    },

    computed: {
        canSendToNespoints() {
            return this.getNespoints &&
                this.form.campaign?.id != this.getNespoints?.id &&
                this.form.campaign
        },
        currentFormHasValidFile() {
            return !!(this.form.files.filter(
                (el) => el.fileStatus.status === "error"
            ).length === 0 && this.form.files.length > 0);
        },
        currentFormHasValidTeam() {
            return !!(this.form.team.length);
        },
        currentFormHasExecutionType() {
            return !!(this.form.execution);
        },
        currentFormHasContestCategory() {
            return !!(this.form.categories?.length);
        },
        failedResponses() {
            return this.responseList?.filter(({ success }) => !success);
        },
        executionsWithError() {
            return this.formList?.filter(({ error }) => error);
        },
        stageEnabled() {
            if (this.currentFormHasValidFile) {
                if (this.currentFormHasValidTeam) {
                    if (this.currentFormHasExecutionType) {
                        return 4;
                    }
                    return 3;
                }
                return 2
            }
            return 1;
        },
        isValidStage() {
            switch (this.formStage) {
                case 1: {
                    return this.currentFormHasValidFile;
                }
                case 2: {
                    return this.currentFormHasValidTeam;
                }
                case 3: {
                    return this.currentFormHasExecutionType;
                }
                case 4: {
                    return this.currentFormHasContestCategory;
                }
                default: {
                    return false;
                }
            }
        },
        isInvalidExecutionModalOpen() {
            return this.modals["invalid-execution"];
        },
        isSendNespointsModalOpen() {
            return this.modals["send-nespoints"];
        },
        isConfirmSoldModalOpen() {
            return this.modals["confirm-sold"];
        },
        isChangeSoldModalOpen() {
            return this.modals["change-sold"];
        },
        isResponseErrorModalOpen() {
            return this.modals["response-error"];
        },
        currentActivity() {
            return this.$page.props.auth.user.participant.currentActivity;
        },
        filteredUsers() {
            return this.users.filter(
                (user) =>
                    `${user?.user?.name} ${user?.codeSap}`
                        .toLowerCase()
                        .indexOf(this.searchName.toLowerCase()) > -1
            );
        },
        getNespoints() {
            return this.validCampaings.filter(
                (el) => el.name == "Nespoints"
            )[0];
        },
        validCampaings() {
            return this.contests.filter((contest) => {
                return (
                    new Date(contest.endDate) >= new Date() &&
                    new Date(contest.startDate) <= new Date()
                );
            });
        },
        hasContestSelected() {
            return !!this.form.campaign;
        }
    },

    methods: {
        restart() {
            this.resetState();

            this.loadContest(this.currentContest?.id);
            this.addExecution();
            this.openModal('confirm-sold');
            this.loadCurrentActivity();
        },
        resetState() {
            this.users = [];
            this.contests = [];
            this.executions = [];
            this.categories = [];
            this.modals = {
                'invalid-execution': false,
                'send-nespoints': false,
                'confirm-sold': false,
                'change-sold': false,
                'response-error': false,
            };
            this.form = {
                store: "",
                campaign: this.currentContest,
                categories: [],
                execution: "",
                team: [],
                files: [],
                sendToNespoint: false,
            };
            this.formList = [];
            this.formStage = 0;

            this.showSelectParticipants = false;
            this.searchName = '';

            this.responseList = [];
            this.disableButton = false;
            this.showTooltip = false;
            this.showResponseModal = false;
        },
        openFileInput() {
          this.$refs['input-file'].click();
        },
        startVideo: async () => {
            setTimeout(async () => {
                const video = document.querySelector("#video");
                const stream = await navigator.mediaDevices.getUserMedia({
                    video: {
                        width: {
                            min: 1280,
                            ideal: 1280,
                            max: 1280,
                        },
                        height: {
                            min: 720,
                            ideal: 720,
                            max: 720,
                        },
                        facingMode: "environment",
                    },
                    audio: false,
                });
                video.srcObject = stream;
            }, 100);
        },
        capturePhoto() {
            this.camera.isPhotoCaptured = true;

            const canvas = document.querySelector("#canvas");
            canvas
                .getContext("2d")
                .drawImage(video, 0, 0, canvas.width, canvas.height);
            const dataUrlString = canvas.toDataURL("image/jpeg");

            const fileName = `Foto ${(this.form.files.length || 0) + 1}.jpeg`;

            function dataURLtoFile(dataurl, filename) {
                let arr = dataurl.split(","),
                    mime = arr[0].match(/:(.*?);/)[1],
                    bstr = atob(arr[1]),
                    n = bstr.length,
                    u8arr = new Uint8Array(n);

                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n);
                }

                return new File([u8arr], filename, { type: mime });
            }

            //Usage example:
            const file = dataURLtoFile(dataUrlString, fileName);
            this.camera.blobPhoto = file;
        },
        clearCapturedPhoto() {
            this.camera.isPhotoCaptured = false;
            this.camera.blobPhoto = undefined;
        },
        cancelCapturePhoto() {
            if (this.camera.isPhotoCaptured) {
                this.clearCapturedPhoto();
            } else {
                this.closeCapturePhoto();
            }
        },
        closeCapturePhoto() {
            this.showCaptureLocalPhotos = false;
            const video = document.querySelector("#video");
            video.srcObject.getVideoTracks().forEach((track) => track.stop());
        },
        removeFile(key) {
            this.form.files.splice(key, 1);
        },
        async includePhoto() {
            let files = [this.camera.blobPhoto];

            if (this.form.files.length < 5) {
                for (let i = 0; i < files.length && i < 5; i++) {
                    let condition2 =
                        ["image/png", "image/jpg", "image/jpeg"].indexOf(
                            files[i].type
                        ) < 0;

                    if (!condition2) {
                        files[i].fileStatus = {
                            status: "success",
                            message: "Tudo certo!",
                        };
                    }

                    if (condition2) {
                        files[i].fileStatus = {
                            status: "error",
                            message: "Formato inválido",
                        };
                    }

                    await this.validateDuplicatedImageInDatabase(files[i]),
                    await this.validateDuplicatedImageInExecution(files[i]),
                    await this.validateOneDuplicatedImageInLocalForms(files[i]);

                    this.form.files.push(files[i]);

                    this.showLocalPhotos = false;
                }
                this.clearCapturedPhoto();
            } else {
                this.showModalPhotoLimit = true;
                this.showCaptureLocalPhotos = false;
                this.showLocalPhotos = false;
                this.clearCapturedPhoto();
            }

        },
        async loadPhoto(e) {
            if (this.form.files.length + e.target.files.length <= 5) {
                for (let i = 0; i < e.target.files.length && i < 5; i++) {
                    let condition2 =
                        ["image/png", "image/jpg", "image/jpeg"].indexOf(
                            e.target.files[i].type
                        ) < 0;

                    if (!condition2) {
                        e.target.files[i].fileStatus = {
                            status: "success",
                            message: "Tudo certo!",
                        };
                    }
                    if (condition2) {
                        e.target.files[i].fileStatus = {
                            status: "error",
                            message: "Formato inválido",
                        };
                    }

                    await this.validateDuplicatedImageInDatabase(e.target.files[i]);
                    await this.validateDuplicatedImageInExecution(e.target.files[i]);
                    await this.validateOneDuplicatedImageInLocalForms(e.target.files[i]);

                    e.target.files[i].src = URL.createObjectURL(
                        e.target.files[i]
                    );

                    this.form.files.push(e.target.files[i]);

                    this.showLocalPhotos = false;
                }
            } else {
                this.showModalPhotoLimit = true;
                this.showLocalPhotos = false;
            }
        },
        async validateDuplicatedImageInDatabase(file) {
            file.fileStatus.hashAlreadyExistsInDatabase = false;

            const fileInfo = {
              size: file.size,
              type: file.type
            }

            const fileSizeInMbs = Math.round(fileInfo.size/1024/1024);
            Sentry.setTag('fileType', fileInfo.type);
            Sentry.setTag('fileSizeInMbs', fileSizeInMbs);

            if (file.fileStatus.status == "success") {
                const uploadImageFormData = new FormData();
                uploadImageFormData.append("contestId", this.form.campaign.id);
                uploadImageFormData.append("file", file);
                try {
                    const { data } = await axios.post(
                        route("gallery.validate-image"),
                        uploadImageFormData
                    );

                    if (data.error) {
                      throw new Error(data.error);
                    }

                    const requestHash = data?.hash;

                    if (!data?.success) {
                      Sentry.captureException('Foto duplicada', {extra: {
                        data: JSON.stringify(data),
                        fileInfo,
                      }});
                      file.fileStatus.hashAlreadyExistsInDatabase = true;
                      file.fileStatus.message = "Essa foto já está em outra execução."
                    } else {
                      file.fileStatus.hash = requestHash;
                    }
                } catch (error) {
                  Sentry.captureException('CATCH: Foto duplicada', {extra: {
                    error: JSON.stringify(error),
                    fileInfo,
                  }});
                  file.fileStatus.status = 'error';
                  file.fileStatus.message = error;

                  file.fileStatus.message = await this.validateStatusImage(
                    file.fileStatus.message.response,
                    file.fileStatus.message.response?.status
                  );
                }
            }
        },
        async validateDuplicatedImageInExecution(file) {
            const currentFileHash = file.fileStatus?.hash;

            const hashAlreadyExistsInExecution = this.form.files?.find(file => {
                const fileHash = file?.fileStatus.hash;
                return fileHash === currentFileHash;
            });

            if (hashAlreadyExistsInExecution) {
                file.fileStatus.status = 'error';
                file.fileStatus.message = 'Foto já em uso nessa campanha';
            }
        },
        async validateOneDuplicatedImageInLocalForms(file) {
            file.fileStatus.hashAlreadyExistsInFormList = false;

            const currentFileHash = file.fileStatus.hash;

            const hashAlreadyExistsInFormList = this.formList?.find(form => {
                if (form.campaign?.id !== this.form.campaign.id) return false;

                const hasFile = form.files?.find(file => {
                    const fileHash = file?.fileStatus.hash;

                    return fileHash === currentFileHash;
                });

                return hasFile;
            });

            if (hashAlreadyExistsInFormList) {
              file.fileStatus.hashAlreadyExistsInFormList = true;
              file.fileStatus.message = "Essa foto já está em outra execução."
              this.showModalHashAlreadyExistsInFormList = true;
            }
        },
        async validateStatusImage(response, status) {
            if(response && status == 402)
              return 'Erro na requisição, tente novamente.'

            if(response && status == 419)
              return 'Sua sessão está expirada, por favor conecte novamente.'

            if(response && status == 504)
              return 'Tempo de resposta demorou mais que o esperado, tente novamente.'

          return 'Não foi possível enviar as fotos ao servidor, tente novamente.';
        },
        async validateAllDuplicatedImageInLocalForms() {

            this.formList.reduce((prev, curr) => {
                curr.files.forEach(file => {

                    file.fileStatus.hashAlreadyExistsInFormList = false;

                    const currentFileHash = file.fileStatus.hash;

                    const hashAlreadyExistsInFormList = prev.find(form => {
                        if (form.campaign?.id !== curr.campaign.id) return false;

                        const hasFile = form.files?.find(file => {
                            const fileHash = file?.fileStatus.hash;

                            return fileHash === currentFileHash;
                        });

                        return hasFile;
                    });

                    if (hashAlreadyExistsInFormList) {
                        file.fileStatus.hashAlreadyExistsInFormList = true;
                    }
                })

                prev.push(curr);
                return prev;
            }, []);
        },
        changeSendToNespoints(newValue) {
            this.form.sendToNespoint = newValue;
        },
        addExecution() {
            this.formStage = 0;
            this.initForm();
        },
        initForm(initialForm) {
            if (initialForm) {
                this.form = initialForm;
            } else {
                const lastIndex = this.formList.length - 1;
                const lastForm = this.formList[lastIndex > 0? lastIndex: 0];

                if (lastForm) {
                    this.form.team = lastForm.team;
                } else {
                    this.autoLoadTeam();
                }
            }

            this.nextStage();
        },
        handleExecutionFormComplete() {
            if (this.form.isEditing) {
                this.form.isEditing = false;
                this.formList.filter((el) => el === this.form)[0] = this.form;

                this.clearForm();
                this.formStage = 0;
                return;
            }

            this.formList.push(this.form);
            this.clearForm();

            this.formStage = 0;
        },
        clearForm() {
            const newForm = {
                store: this.form.store,
                campaign: this.form.campaign,
                categories: [],
                execution: "",
                team: [],
                files: [],
                sendToNespoint: false,
            };

            this.form = newForm;
        },
        nextStage() {
            if (this.formStage == 4) {
                this.handleExecutionFormComplete();
                return;
            }

            this.formStage++;
        },
        needsToConfirmSubregion() {
            return (
                this.form.store?.subregionId !== this.currentRegion?.subregionId
            );
        },
        openModal(modal) {
            this.modals[modal] = true;
        },
        closeModal(modal) {
            this.modals[modal] = false;
        },
        prevStage() {
            if (this.formStage < 1) {
                this.formStage = 0;
                return;
            }

            this.formStage--;
        },
        editExecution(item) {
            if (this.disableButton) return;

            item.isEditing = true;
            this.form = item;
            item.error = false;
            this.initForm(item);
        },
        async removeExecution(item) {
            if (this.disableButton) return;

            this.formList = this.formList.filter((el) => el != item);
            await this.validateAllDuplicatedImageInLocalForms();
        },
        async loadCurrentActivity() {
            const { data } = await axios.get(this.route('api.participants.get-current-activity'));

            if (data.data) {
                const currentActivity = data.data;
                this.$page.props.auth.user.participant.currentActivity = currentActivity;
            }
        },
        autoLoadTeam() {
            if (!this.form.team?.length) {
                const participant = { ...this.$page.props.auth.user.participant, user: this.$page.props.auth.user };
                this.form.team.push(participant);
            }
        },
        loadPdvRegion(regionId) {
            this.fetchContests(regionId);
            axios
                .get(`/region/${regionId}/users`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.team = [];

                    this.autoLoadTeam();
                    data = data.filter((user) => {
                        if (
                            user.id == this.$page.props.auth.user.participant.id
                        ) {
                            return false;
                        } else {
                            return true;
                        }
                    });

                    this.users = data;

                    for (let i = 0; i < Object.keys(this.$refs).length; i++) {
                        if (this.$refs[`checkbox-` + i]) {
                            this.$refs[`checkbox-` + i].checked = false;
                        }
                    }
                });
        },
        setUser(user) {
            if (this.form.team.includes(user)) {
                let index = this.form.team.indexOf(user);
                this.form.team.splice(index, 1);
            } else {
                this.form.team.push(user);
            }
        },
        hasUser(user) {
            return this.form.team.includes(user);
        },
        fetchContests(regionId) {
            axios
                .get(this.route('contest.options', { regionId }), {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    const { contests } = data;

                    this.contests = contests || [];
                });
        },
        loadContest(contestId) {
            if(!contestId) return;
            axios
                .get(`/contest/${contestId}`, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then(({ data }) => {
                    this.form.campaign = data;
                    this.categories = data?.categories.map((item) => ({
                        name: `${item.description} ${!!item?.brand ? ` (${item.brand.name})` : ''}`,
                        id: item.id,
                    }));
                    this.executions = data?.executionTypes.map((item) => ({
                        name: item.description,
                        id: item.id,
                        weight: item.weight,
                        imageUrl: (ContestExecutionTypes.find(({ name }) => name?.toUpperCase() === item?.description?.toUpperCase()))?.imageUrl
                    }));
                });
        },
        async submit() {
            this.responseList = [];
            this.disableButton = true;

            await Promise.all(
                this.formList.map(async (el, key) => {
                    if (el.success) return;

                    const formData = {};
                    const blobIndex = uuidV4();
                    formData.blobIndex = blobIndex;
                    formData.campaign = el.campaign.id;

                    formData.categories = el.categories.map((category) => category.id);

                    formData.store = el.store.id;
                    formData.execution = el.execution.id;

                    if (
                        el.sendToNespoint &&
                        el.campaign.id != this.getNespoints?.id
                    ) {
                        formData.optionalCampaign = this.getNespoints?.id;
                    } else {
                        formData.optionalCampaign = "";
                    }

                    formData.team = el.team.map((user) => user.id);
                    formData.files = [];

                    let fileUploadError = false;

                    await Promise.all(
                        el.files.map(async (file, key) => {
                            if (file.fileStatus.status == "success") {
                                const fileInfo = {
                                  size: file.size,
                                  type: file.type
                                }

                                const fileSizeInMbs = Math.round(fileInfo.size/1024/1024);
                                Sentry.setTag('fileType', fileInfo.type);
                                Sentry.setTag('fileSizeInMbs', fileSizeInMbs);

                                if (!file.fileStatus.hashAlreadyExistsInDatabase) {
                                    await this.validateDuplicatedImageInDatabase(file)
                                }

                                const uploadImageFormData = new FormData();
                                uploadImageFormData.append(
                                    "blobIndex",
                                    blobIndex
                                );
                                uploadImageFormData.append("file", file);
                                try {
                                    const { data } = await axios.post(
                                        route("gallery.upload-image"),
                                        uploadImageFormData
                                    );

                                    if (data?.success) {
                                        formData.files.push({
                                            url: data.success,
                                            blobId: file.fileStatus.hash,
                                        })

                                        file.fileStatus = "uploaded";
                                        file.url = data.success;
                                        file.blobId = file.fileStatus?.hash;
                                    } else {
                                        Sentry.captureException('Erro ao subir foto', {extra: {
                                          data: JSON.stringify(data),
                                          fileInfo,
                                        }});

                                        fileUploadError = true;
                                    }
                                } catch (error) {
                                    Sentry.captureException('CATCH: Erro ao subir foto', {extra: {
                                      error: JSON.stringify(error),
                                      fileInfo,
                                    }});
                                    fileUploadError = true;
                                }
                                // 50Mb
                            } else if (file.fileStatus.status == "uploaded") {
                                formData.files.push({ url: file.url, blobId: file.blobId });
                            }
                        })
                    );

                    if (el.files.some(({ fileStatus }) => fileStatus.hashAlreadyExistsInDatabase || fileStatus.hashAlreadyExistsInFormList)) {
                        formData.toReprove = true;
                    }

                    if (!fileUploadError) {
                        await axios
                            .post("/upload-photos/save", formData, {
                                preserveState: true,
                                preserveScroll: true,
                            })
                            .then(({ data }) => {
                                this.responseList.push({
                                    key: key + 1,
                                    name: !data?.nespointsError
                                        ? `Execução ${key + 1}`
                                        : `Execução ${key + 1} (NESPOINTS)`,
                                    nespointsError: data.nespointsError,
                                    success: data.success,
                                    message: data.message,
                                });

                                if (data.success) {
                                    el.success = true;
                                } else {
                                    Sentry.captureException('Erro ao subir execução', {extra: {
                                        data: JSON.stringify(data)
                                    }});

                                    el.error = true;
                                }
                            }).catch((error) => {
                                Sentry.captureException('CATCH: Erro ao subir execução.', {extra: {
                                    error: JSON.stringify(error)
                                }});

                                this.responseList.push({
                                    key: key + 1,
                                    success: false,
                                    message: `Sem acesso à rede: Não foi possível conectar ao servidor. Verifique suas configurações de rede e tente novamente.`,
                                });

                                el.error = true;
                            });
                    } else {
                        this.responseList.push({
                            key: key + 1,
                            success: false,
                            message: `Sem acesso à rede: Não foi possível conectar ao servidor. Verifique suas configurações de rede e tente novamente.`,
                        });

                        el.error = true;
                    }
                })
            );

            if (this.responseList.find(({ success }) => !success)) {
                this.openModal('response-error');
            } else {
                this.showResponseModal = true;
            }
            this.disableButton = false;
        },
    },
};
</script>
<style>
    .grid-icon-template {
        grid-template-columns: min-content auto;
    }
</style>
